module.exports = __webpack_public_path__ + "static/media/lisp.9da9f3ac.svg";